// Meyar has three pages with fully bespoke sections that don't fit the
// generic InnerPage renderer well, so they're built as individual React
// components in /pages/inner/. This data file just holds shared strings.

export const MEYAR_SHARED_FEATURES = [
  "AI on every risk — the assistant suggests the control, drafts the treatment plan and proposes wording an auditor will accept. Risk owners stop staring at an empty box.",
  "Risk register with inherent and residual scoring and full change history.",
  "Controls built once and reused.",
  "Framework mapping.",
  "Policy management with attestations.",
  "Evidence gathered continuously.",
  "Dashboards and one-click board packs.",
  "Arabic and English.",
];

export const MEYAR_SPREADSHEET_BREAKS = [
  "Nobody knows which version is real.",
  "Controls exist on paper and nowhere else.",
  "Evidence is gathered the week before the audit.",
  "The board sees a PDF once a quarter.",
  "The regulator asks a question and you need three days.",
];

export const MEYAR_COMPARISON = [
  { label: "What it governs", enterprise: "The whole enterprise", cyber: "Information-security controls" },
  { label: "Risks covered", enterprise: "Strategic, operational, financial, compliance, third-party", cyber: "Confidentiality, integrity, availability, privacy" },
  { label: "Frameworks", enterprise: "PDPL, ISO 31000, corporate policy", cyber: "ISO 27001 Annex A, NIST CSF, PCI DSS, SOC 2" },
  { label: "Who owns it", enterprise: "CRO, Compliance, Internal Audit, Company Secretary", cyber: "CISO, Head of Security, IT Governance" },
  { label: "The question it answers", enterprise: "Are we in control of the business?", cyber: "Are we in control of our security posture?" },
];

export const MEYAR_EDITIONS = [
  { name: "Meyar Starter", body: "For teams starting from spreadsheets. Core risk register, controls and evidence." },
  { name: "Meyar Professional", body: "Adds policy management, framework mapping and attestations." },
  { name: "Meyar Enterprise", body: "Unlimited users, multiple frameworks, SSO, dedicated deployment. Available on both product lines." },
];

export const MEYAR_ONBOARDING = [
  "Week 1 — configure and import from Excel.",
  "Weeks 2–3 — load and map the control framework.",
  "Weeks 4–6 — policies, attestations, dashboards.",
  "Then training and handover.",
];
